export default function (exchanges, search = '') {
  return search
    ? exchanges.filter(
        (c) =>
          c.gv.cur.name.toLowerCase().includes(search.toLowerCase()) ||
          c.gv.cur.code.toLowerCase().includes(search.toLowerCase())
      )
    : exchanges;
}
